import { render, staticRenderFns } from "./PrintPanelPlugin.vue?vue&type=template&id=2dc549d4&scoped=true"
import script from "./PrintPanelPlugin.vue?vue&type=script&lang=ts"
export * from "./PrintPanelPlugin.vue?vue&type=script&lang=ts"
import style0 from "./PrintPanelPlugin.vue?vue&type=style&index=0&id=2dc549d4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc549d4",
  null
  
)

export default component.exports